@switch (status()) {
  @case ("ok") {
    <svg-icon src="assets/images/icons/status-ok.svg"></svg-icon>
  }
  @case ("active") {
    <svg-icon src="assets/images/icons/status-ok.svg"></svg-icon>
  }
  @case ("active-corero-filters") {
    <svg-icon src="assets/images/icons/status-ok.svg"></svg-icon>
  }

  @case ("notraffic") {
    <svg-icon src="assets/images/icons/status-no-traffic.svg"></svg-icon>
  }
  @case ("inactive-corero-filters") {
    <svg-icon src="assets/images/icons/status-no-traffic.svg"></svg-icon>
  }

  @case ("malfunction") {
    <svg-icon src="assets/images/icons/status-warning.svg"></svg-icon>
  }
  @case ("open-incidents") {
    <svg-icon src="assets/images/icons/status-warning.svg"></svg-icon>
  }

  @case ("initial") {
    <svg-icon src="assets/images/icons/status-pending.svg"></svg-icon>
  }
  @case ("pending") {
    <svg-icon src="assets/images/icons/status-pending.svg"></svg-icon>
  }

  @default {
    <svg-icon src="assets/images/icons/status-unknown.svg"></svg-icon>
  }
}
